import gql from 'graphql-tag';

// Exactly the fields ShortCard renders or tracks. `__typename` is not selected
// explicitly — Apollo injects it, and GenericExploreContent switches on it.
const HOME_DAILY_SELECTION_TOOL_FRAGMENT = gql`
  fragment HomeDailySelectionToolFields on Tool {
    id
    title
    slug
    summary
    isFavourite
    estimatedMins
    cloudinaryThumbnail {
      path
    }
    mediaType {
      value
    }
    exploreCategory {
      id
      slug
      internalName
    }
  }
`;

export const HOME_TOOLS_FOR_YOUR_DAY_QUERY = gql`
  ${HOME_DAILY_SELECTION_TOOL_FRAGMENT}
  query HomeToolsForYourDay($userLocalDateTime: DateTime!) {
    user {
      id
      dailySelection(userLocalDateTime: $userLocalDateTime) {
        beforeWork {
          ...HomeDailySelectionToolFields
        }
        duringWork {
          ...HomeDailySelectionToolFields
        }
        afterWork {
          ...HomeDailySelectionToolFields
        }
      }
    }
  }
`;
